import React from 'react';

import PropTypes from 'prop-types';

import ValueItem from 'components/Widgets/Profile/ValueItem';

export default function HireDate({ member }) {
  return (

    <ValueItem
      icon="time-zone-icon"
      label="Hire Date"
    >
      {member.hired_date_formatted}
    </ValueItem>
  );
}

HireDate.propTypes = {
  member: PropTypes.object.isRequired,
};
